// One icon set everywhere, lucide (packages/ui/DESIGN.md "Icons"). This page is vanilla TS, not
// React, so it uses lucide's framework-agnostic entry point rather than lucide-react — the same
// icon geometry `@preedanext/ui/icons` wraps, not a second icon set.
import {
  Box,
  Copy,
  createElement,
  Download,
  ExternalLink,
  FileText,
  Film,
  type IconNode,
  Image,
  Palette,
  QrCode,
  Search,
  Type,
  Volume2,
  X,
} from "lucide";
import type { AssetKind } from "./manifest-types";

export const KIND_ICON: Record<AssetKind, IconNode> = {
  mark: Palette,
  image: Image,
  video: Film,
  model: Box,
  document: FileText,
  font: Type,
  audio: Volume2,
  style: FileText,
  data: FileText,
  world: Image,
  other: FileText,
};

export function icon(node: IconNode, className = "pnx-icon"): SVGElement {
  const el = createElement(node);
  el.setAttribute("class", className);
  el.setAttribute("aria-hidden", "true");
  return el;
}

export { Copy, Download, ExternalLink, QrCode, Search, X };
